import React, { Component } from 'react';
import Select from 'react-select';

import classNames from 'classnames';
import { I18n, translate } from 'components/translate';
import PropTypes from 'prop-types';

import './Select.scss';

@translate()
class SelectInput extends Component {
  static propTypes = {
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    loadingMessage: PropTypes.string,
    noOptionsMessage: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    customStyles: PropTypes.object,
    marginBottom: PropTypes.bool,
    t: PropTypes.func,
    translatable: PropTypes.bool,
    onToogleOpen: PropTypes.func,
    closeClickingOutside: PropTypes.bool,
    components: PropTypes.object,
    hasError: PropTypes.bool
  };

  static defaultProps = {
    isClearable: true,
    loadingMessage: 'select.loadingMessage',
    noOptionsMessage: 'select.noOptionsMessage',
    customStyles: {},
    marginBottom: true,
    translatable: true,
    classNamePrefix: 'select',
    closeClickingOutside: true
  };

  state = {
    isOpen: false
  };

  constructor(props) {
    super(props);

    this.onToogleOpen = this.onToogleOpen.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onToogleOpen(event) {
    const { onToogleOpen } = this.props;

    this.setState({ isOpen: !this.state.isOpen });

    onToogleOpen && onToogleOpen(event);
  }

  onChange(event) {
    const { onChange } = this.props;

    this.setState({ isOpen: false });

    onChange && onChange(event);
  }

  // #region styles
  get dropdownIndicatorStyles() {
    const dropdownIndicatorStyles = this.props.customStyles.dropdownIndicator;

    return (base) => ({
      ...base,
      cursor: 'pointer',
      ...dropdownIndicatorStyles
    });
  }

  get indicatorsContainerStyles() {
    const indicatorsContainerStyles =
      this.props.customStyles.indicatorsContainer;

    return (base) => ({
      ...base,
      cursor: 'pointer',
      ...indicatorsContainerStyles
    });
  }

  get optionStyles() {
    const optionStyles = this.props.customStyles.option;

    return (base) => ({
      ...base,
      cursor: 'pointer',
      ...optionStyles
    });
  }

  get valueContainerStyles() {
    const valueContainerStyles = this.props.customStyles.valueContainer;

    return (base) => ({
      ...base,
      cursor: 'text',
      ...valueContainerStyles
    });
  }

  get disableBoxShadow() {
    return (base) => ({
      ...base,
      cursor: 'text',
      boxShadow: 'none'
    });
  }

  get placeholderStyles() {
    return (base) => ({
      ...base,
      maxWidth: '100%',
      overflow: 'hidden',
      paddingRight: '12px',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    });
  }
  // #endregion

  render() {
    const {
      className,
      isDisabled,
      loadingMessage,
      noOptionsMessage,
      placeholder,
      marginBottom,
      t,
      translatable,
      closeClickingOutside,
      components,
      hasError
    } = this.props;
    const { isOpen } = this.state;

    const translatedPlaceholder =
      placeholder && (translatable ? t(placeholder) : placeholder);

    const mainClass = classNames('select__container', {
      'select__container--bottom__space': marginBottom,
      'select__container--no__bottom__space': !marginBottom,
      'select__container--disabled': isDisabled
    });

    const classesSelect = classNames('class__select', className, {
      'class__select--opened': isOpen,
      'class__select--closed': !isOpen,
      'class__select--error': hasError
    });

    return (
      <div className={mainClass}>
        <Select
          {...this.props}
          className={classesSelect}
          loadingMessage={() => t(loadingMessage)}
          noOptionsMessage={() => t(noOptionsMessage)}
          onChange={this.onChange}
          placeholder={translatedPlaceholder}
          styles={{
            dropdownIndicator: this.dropdownIndicatorStyles,
            indicatorsContainer: this.indicatorsContainerStyles,
            option: this.optionStyles,
            valueContainer: this.valueContainerStyles,
            control: this.disableBoxShadow,
            placeholder: this.placeholderStyles
          }}
          components={{
            IndicatorSeparator: () => null,
            ...components
          }}
          onMenuOpen={this.onToogleOpen}
          onMenuClose={closeClickingOutside && isOpen && this.onToogleOpen}
        />
        {hasError && (
          <div className="class__select__error-label">
            <I18n html label="validations.required" />
          </div>
        )}
      </div>
    );
  }
}

export default SelectInput;
